import axios from "axios";
import Cookies from "js-cookie";

let href = window.location.origin;
href = href.replace("http://", "");
href = href.replace("https://", "");
href = href.split(".")[0];

let BASE_URL = `https://devpuapi.overwatch.ai/users/`;

if (href.includes("localhost")) {
  //use dev route
  BASE_URL = `https://devpuapi.overwatch.ai/users/`;
} else if (href.includes("192")) {
  //use dev route
  BASE_URL = `https://devpuapi.overwatch.ai/users/`;
} else if (href.includes("dev")) {
  //use dev route
  BASE_URL = `https://devpuapi.overwatch.ai/users/`;
} else {
  //use prod route
  BASE_URL = `https://puapi.overwatch.ai/users/`;
}

async function CallAxios(options) {
  try {
    console.log("URL: ", options.url);
    switch (options.type) {
      case "post":
        return await axios.post(options.url, options.params, {
          headers: {
            ...options.headers,
            "Content-Type": "application/json",
            Authorization: `Bearer ${options.accessToken}`,
            AuthRefresh: `Bearer ${options.refreshToken}`,
          },
        });
      case "get":
        return await axios.get(options.url, {
          headers: {
            ...options.headers,
            "Content-Type": "application/json",
            Authorization: `Bearer ${options.accessToken}`,
            AuthRefresh: `Bearer ${options.refreshToken}`,
          },
          params: {
            ...options.params,
          },
        });
      default:
        throw new Error("Invalid axios call type");
    }
  } catch (error) {
    console.trace("Error:", error);
    throw error;
  }
}

export async function login(email, password = null, providerData = null) {
  try {
    return await CallAxios({
      type: "post",
      url: `${BASE_URL}login-site`,
      params: {
        email,
        password,
        providerData,
      },
      accessToken: Cookies.get("accessToken"),
      refreshToken: Cookies.get("refreshToken"),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        AuthRefresh: `Bearer ${Cookies.get("refreshToken")}`,
      },
    });
  } catch (error) {
    throw error;
  }
}

export async function refresh() {
  try {
    const refreshToken = Cookies.get("refreshToken");
    const email = Cookies.get("email");

    if (!refreshToken || !email) {
      console.log("No refresh or email found:", refreshToken, email);
      return;
    }

    return {
      ...(await CallAxios({
        type: "post",
        url: `${BASE_URL}refreshToken`,
        params: {
          email,
          refreshToken,
        },
        refreshToken: Cookies.get("refreshToken"),
        headers: {
          "Content-Type": "application/json",
          AuthRefresh: `Bearer ${Cookies.get("refreshToken")}`,
        },
      })),
      email: email,
    };
  } catch (error) {
    throw error;
  }
}

export async function signup(
  email,
  password,
  name,
  dateOfBirth,
  gdprConsent,
  provider = null
) {
  try {
    return await CallAxios({
      type: "post",
      url: `${BASE_URL}createUser`,
      params: {
        email,
        password,
        name,
        dob: dateOfBirth,
        provider,
        gdprConsent,
      },
      accessToken: Cookies.get("accessToken"),
      refreshToken: Cookies.get("refreshToken"),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        AuthRefresh: `Bearer ${Cookies.get("refreshToken")}`,
      },
    });
  } catch (error) {
    throw error;
  }
}

export async function getPrivacyPolicy() {
  try {
    return await CallAxios({
      type: "get",
      url: `${BASE_URL}getPrivacyPolicy`,
      accessToken: Cookies.get("accessToken"),
      refreshToken: Cookies.get("refreshToken"),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        AuthRefresh: `Bearer ${Cookies.get("refreshToken")}`,
      },
    });
  } catch (error) {
    throw error;
  }
}
export async function getTermsOfUse() {
  try {
    return await CallAxios({
      type: "get",
      url: `${BASE_URL}getTermsOfUse`,
      accessToken: Cookies.get("accessToken"),
      refreshToken: Cookies.get("refreshToken"),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        AuthRefresh: `Bearer ${Cookies.get("refreshToken")}`,
      },
    });
  } catch (error) {
    throw error;
  }
}

export async function signupFollowUp(address, provider = null) {
  try {
    return await CallAxios({
      type: "post",
      url: `${BASE_URL}create`,
      params: {
        address,
        provider,
      },
      accessToken: Cookies.get("accessToken"),
      refreshToken: Cookies.get("refreshToken"),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        AuthRefresh: `Bearer ${Cookies.get("refreshToken")}`,
      },
    });
  } catch (error) {
    throw error;
  }
}

export async function getSubscribedDevices() {
  try {
    return await CallAxios({
      type: "get",
      url: `${BASE_URL}getDeviceSubscriptions`,
      accessToken: Cookies.get("accessToken"),
      refreshToken: Cookies.get("refreshToken"),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        AuthRefresh: `Bearer ${Cookies.get("refreshToken")}`,
      },
    });
  } catch (error) {
    throw error;
  }
}

export async function updateSubscribedDevices(devices) {
  try {
    return await CallAxios({
      type: "post",
      url: `${BASE_URL}updateDeviceSubscriptions`,
      params: {
        subscriptions: devices,
      },
      accessToken: Cookies.get("accessToken"),
      refreshToken: Cookies.get("refreshToken"),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        AuthRefresh: `Bearer ${Cookies.get("refreshToken")}`,
      },
    });
  } catch (error) {
    throw error;
  }
}

export async function activateAccount(email, code) {
  try {
    return await CallAxios({
      type: "post",
      url: `${BASE_URL}activateUser`,
      params: {
        email,
        code,
      },
      accessToken: Cookies.get("accessToken"),
      refreshToken: Cookies.get("refreshToken"),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        AuthRefresh: `Bearer ${Cookies.get("refreshToken")}`,
      },
    });
  } catch (error) {
    throw error;
  }
}

export async function sendActivationCode(email) {
  try {
    console.log("Email in sendActivationCode:", email);
    return await CallAxios({
      type: "post",
      url: `${BASE_URL}resendActivationCode`,
      params: {
        email,
      },
      accessToken: Cookies.get("accessToken"),
      refreshToken: Cookies.get("refreshToken"),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        AuthRefresh: `Bearer ${Cookies.get("refreshToken")}`,
      },
    });
  } catch (error) {
    throw error;
  }
}

// PUBLIC ROUTE API FUNCTIONS
export async function GetPublicDeviceInfo(paramValue) {
  try {
    return new EventSource(
      `${BASE_URL}getPublicDeviceInfo-V2?pool=${paramValue}`
    );
  } catch (error) {
    throw error;
  }
}
